import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { horwathTheme } from '@horwath-htl/shared-branding';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppRoutes } from './components/AppRoutes';
import { AccessDeniedPage } from './pages/AccessDeniedPage';
import { AuthorizationNeededPage } from './pages/AuthorizationNeededPage';
import { LoginPage } from './pages/LoginPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { EULAPage } from './pages/EULAPage';
import DocumentUploadPage from './pages/DocumentUploadPage';
import { UnauthenticatedLayout } from './components/UnauthenticatedLayout';
import { NotificationProvider } from './contexts/NotificationContext';
import 'flag-icons/css/flag-icons.min.css';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={horwathTheme}>
      <NotificationProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/access-denied" element={<AccessDeniedPage />} />
          <Route path="/authorization-needed" element={<AuthorizationNeededPage />} />
          
          {/* Unauthenticated routes with layout */}
          <Route element={<UnauthenticatedLayout />}>
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/eula" element={<EULAPage />} />
            <Route path="/document-upload" element={<DocumentUploadPage />} />
          </Route>
          
          <Route path="*" element={
            <ProtectedRoute>
              <AppRoutes />
            </ProtectedRoute>
          } />
        </Routes>
      </NotificationProvider>
    </ThemeProvider>
  );
};

export default App;